import axios from 'axios';
import { groupBy, mergeArrsByKey } from '@/helpers';

import { httpWithLoader, http } from '@/http-common';

const state = () => ({
    standards: [], // Список стандартов
    allKindsList: [], // список всех ВПД
    qualificationsList: [], // список всех квалификаций
    educationForms: [], // список форм образовательных программ
    educationTypes: [], // список типов образовательных программ
});

const mutations = {
    SET_ALL_KINDS_ITEMS(state, allKindsList) {
        state.allKindsList = allKindsList;
    },
    SET_QUALIFICATIONS_LIST(state, qualificationsList) {
        state.qualificationsList = qualificationsList;
    },
    SET_STANDARDS(state, standards) {
        state.standards = standards;
    },
    SET_EDUCATION_FORMS(state, educationForms) {
        state.educationForms = educationForms
    },
    SET_EDUCATION_TYPES(state, educationTypes) {
        state.educationTypes = educationTypes
    },

    ADD_KIND(state, kind) {
        state.allKindsList.push(kind);
    },
    ADD_QUALIFICATION(state, qualification) {
        state.qualificationsList.push(qualification);
    },
    ADD_STANDARDS(state, standards) {
        state.standards.push(standards);
    },
};

const handleError = ((error, commit) => {
    commit('common/TOGGLE_ALERT', { open: true, status: 'error', text: `Что то пошло не так, пожалуйста перезагрузите страницу и попробуйте ещё раз` }, { root: true })
    console.log(`url: ${ error.config ? error.config.url : '-' }\nmethod: ${ error.config ? error.config.method : '-' }\npayload: ${ error.config ? error.config.data : '-' }`);

    if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        const tempMessage = error.response.data.trace.map(el => el.file).join('\n')
        console.log(`message: ${error.response.data.message}\nfiles:\n${tempMessage}`);
    } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the 
        // browser and an instance of
        // httpWithLoader.ClientRequest in node.js
        console.log(error.request);
    } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Ошибка', error.message);
    }
});

const actions = {
    /*--------- ВПД ---------*/
    // Получить все ВПД
    async LOAD_ALL_KINDS({ commit, rootState }) {
        return await httpWithLoader.get(`/${rootState.ork.curOrkId}/kinds`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_ALL_KINDS_ITEMS', response.data);
            return response.data;
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },
    // Получить все ВПД не включая глобальный прелоадер
    async SILENT_LOAD_ALL_KINDS({ commit, rootState }) {
        return await http.get(`/${rootState.ork.curOrkId}/kinds`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_ALL_KINDS_ITEMS', response.data);
            return response.data;
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },
    // Создать ВПД
    async CREATE_KIND({ commit, rootState }, params) {
        return await httpWithLoader.post(`/${rootState.ork.curOrkId}/kinds`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('ADD_KIND', response.data);

            return response.data;
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    /*--------- КВАЛИФИКАЦИИ ---------*/
    // Получить список квалификаций
    async LOAD_QUALIFICATIONS_LIST({ commit, rootState }) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/qualifications`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_QUALIFICATIONS_LIST', response.data);
        });
    },
    // Получить список квалификаций не включая глобальный прелоадер
    async SILENT_LOAD_QUALIFICATIONS_LIST({ commit, rootState }) {
        await http.get(`/${rootState.ork.curOrkId}/qualifications`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_QUALIFICATIONS_LIST', response.data);
        });
    },
    // Создать квалификацию
    async CREATE_QUALIFICATION({ commit, rootState }, params) {
        return await httpWithLoader.post(`/${rootState.ork.curOrkId}/qualifications`, params, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('ADD_QUALIFICATION', response.data);

            return response.data;
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    /*--------- СТАНДАРТЫ ---------*/
    // Получить список стандартов
    async LOAD_STANDARDS({ commit, rootState }, id) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/standards`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_STANDARDS', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить список стандартов не включая глобальный прелоадер
    async SILENT_LOAD_STANDARDS({ commit, rootState }, id) {
        await http.get(`/${rootState.ork.curOrkId}/standards`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_STANDARDS', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    /*--------- ФОРМЫ ОБУЧЕНИЯ ---------*/
    // Получить список форм обучений
    async LOAD_EDUCATION_FORMS({ commit, rootState }) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/education-forms`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_EDUCATION_FORMS', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить список форм обучений не включая глобальный прелоадер
    async SILENT_EDUCATION_FORMS({ commit, rootState }) {
        await http.get(`/${rootState.ork.curOrkId}/education-forms`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_EDUCATION_FORMS', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    /*--------- ТИПЫ ОБУЧЕНИЯ ---------*/
    // Получить список форм обучений
    async LOAD_EDUCATION_TYPES({ commit, rootState }) {
        await httpWithLoader.get(`/${rootState.ork.curOrkId}/education-types`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_EDUCATION_TYPES', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },

    // Получить список форм обучений не включая глобальный прелоадер
    async SILENT_EDUCATION_TYPES({ commit, rootState }) {
        await http.get(`/${rootState.ork.curOrkId}/education-types`, {
            headers: {
                'Authorization': `bearer ${rootState.tokens.accessToken}`
            }
        })
        .then((response) => {
            commit('SET_EDUCATION_TYPES', response.data);
        })
        .catch((reject) => {
            handleError(reject, commit)
        });
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
